import { Link } from "react-router-dom";
import { Instagram, Mail, Phone } from "lucide-react";
import { BRAND, NAV_LINKS, CONTACT_INFO, ZENITH, POLICY_LINKS } from "@/data/siteData";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#1A1A1A] text-white pt-24 pb-12 mt-auto">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 pb-16 border-b border-white/10">
          <div>
            <img src={BRAND.logoWhite} alt="The Market Place" className="h-16 w-auto mb-8" />
            <p className="font-extrabold text-3xl sm:text-4xl leading-tight">{BRAND.tagline}</p>
            <p className="mt-3 text-sm text-white/50 tracking-wide">{BRAND.subTagline}</p>
          </div>
          <div className="grid grid-cols-2 sm:flex sm:justify-end gap-10 sm:gap-16">
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5 font-mono">Quick Links</p>
              <div className="flex flex-col gap-3">
                {NAV_LINKS.map((l) => (
                  <Link key={l.path} to={l.path} data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-sm text-white/70 hover:text-[#F48FB1] transition-colors duration-300">
                    {l.label}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5 font-mono">Connect</p>
              <div className="flex flex-col gap-4 text-sm text-white/70">
                <a href={`mailto:${CONTACT_INFO.email}`} data-testid="footer-email-link" className="flex items-center gap-2 hover:text-[#F48FB1] transition-colors duration-300">
                  <Mail size={15} /> {CONTACT_INFO.email}
                </a>
                <a href={`tel:${CONTACT_INFO.phone}`} data-testid="footer-phone-link" className="flex items-center gap-2 hover:text-[#F48FB1] transition-colors duration-300">
                  <Phone size={15} /> {CONTACT_INFO.phone}
                </a>
                <a href={CONTACT_INFO.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="flex items-center gap-2 hover:text-[#F48FB1] transition-colors duration-300">
                  <Instagram size={15} /> {CONTACT_INFO.instagramHandle}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center gap-6 pt-8">
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            {POLICY_LINKS.map((link) => (
              <Link
                key={link.id}
                to="/policies"
                data-testid={`footer-policy-link-${link.id}`}
                className="text-xs font-semibold text-white/60 hover:text-[#F48FB1] transition-colors duration-300"
              >
                {link.label}
              </Link>
            ))}
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 w-full">
            <p className="text-xs text-white/30">© 2026 the farmers market, Jaipur. All rights reserved.</p>
            <a
              href={ZENITH.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-zenith-credit-link"
              className="text-xs text-white/30 hover:text-white/60 transition-colors duration-300"
            >
              Design & Development by {ZENITH.name}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
